import { Outlet, useParams } from 'react-router-dom'

import { AccountsCardsDataTableDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CardsDataTable } from '../CardsDataTable'

const AccountCardsDataTable = () => {
  const { id } = useParams<{ id: string }>()
  const { loading, data } = useQuery(AccountsCardsDataTableDocument)
  const cardholders = data?.banking.cardholders ?? []
  const companyId = useCurrentSession().company.id

  return (
    <>
      <Outlet />
      {!loading && (
        <CardsDataTable
          bankAccountId={id}
          cardholders={cardholders}
          companyId={companyId}
          tableIdentifier={`AccountCardsTable/${id}`}
          canAddCard={false}
        />
      )}
    </>
  )
}

export default AccountCardsDataTable
